(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fourthd-cards"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const row = document.querySelector(".fourthd-cards-row");
  const prev = document.querySelector(".carousel-prev");
  const next = document.querySelector(".carousel-next");

  if(row && prev && next){
    prev.addEventListener("click", () => {
      row.scrollBy({ left: -row.offsetWidth, behavior: "smooth" });
    });
    next.addEventListener("click", () => {
      row.scrollBy({ left: row.offsetWidth, behavior: "smooth" });
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
